import type { AuthContextType } from '@context/auth.context';
import type { ApiMessage } from '@interfaces/message';
import { apiRequest, isResponse } from '@services/fetcher';

async function searchMessagesInConversation(auth: AuthContextType, conversationId: number, query: string) {
  const params = new URLSearchParams({
    chatId: String(conversationId),
    query,
  });

  const url = `${import.meta.env.VITE_API_URL}/conversation/search-messages?${params.toString()}`;

  const response = await apiRequest<ApiMessage[]>(url, auth);

  if (isResponse(response)) {
    throw new Error('Unexpected response');
  }

  if (response instanceof Error) {
    throw response;
  }

  return response;
}

export default searchMessagesInConversation;
